// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-bar{position:fixed;bottom:0;width:100%;display:flex;justify-content:space-between;align-items:center;padding:24px 50px;gap:40px;background:#fff;border-radius:24px 24px 0 0;box-shadow:0px 0px 4px rgba(98,87,109,.04),8px 0px 24px rgba(98,87,109,.08);z-index:2}", ""]);
// Exports
module.exports = exports;
